import { type ComponentChildren } from 'preact'
import { Link, useLocation } from 'wouter-preact'
import { clsx } from 'clsx'

import {
	BillingAndPlansIcon,
	HomeIcon,
	IntegrationsIcon,
	ProfileIcon,
	TeamsIcon,
	Typography
} from 'components/UI'

type SidebarRoute = {
	/** A unique key to help React/Preact identify each route in an array */
	key: string
	/** The visible title of the route */
	title: string
	/** The URL path for the route */
	url: string
	/** An icon to display next to the title */
	icon: ComponentChildren
}

const settingsRoutes: SidebarRoute[] = [
	{
		key: 'profile',
		title: 'Profile',
		url: '/profile',
		icon: <ProfileIcon />
	},
	{
		key: 'teams',
		title: 'Teams',
		url: '/teams',
		icon: <TeamsIcon />
	},
	{
		key: 'billing',
		title: 'Billing and Plans',
		url: '/billing',
		icon: <BillingAndPlansIcon />
	},
	{
		key: 'integrations',
		title: 'Integrations',
		url: '/integrations',
		icon: <IntegrationsIcon />
	},
	{
		key: 'home',
		title: 'Home',
		url: '/',
		icon: <HomeIcon />
	}
]

const SidebarItem = ({
	route,
	isActive
}: {
	route: SidebarRoute
	isActive: boolean
}) => (
	<li>
		<Link
			aria-current={isActive ? 'page' : undefined}
			class={clsx(
				'group mx-2.5 flex h-10 flex-1 items-center gap-2 rounded px-2.5 py-2 text-black-200 hover:bg-black-800 hover:text-black-100',
				isActive && 'bg-black-800 text-product hover:text-product'
			)}
			href={route.url}
		>
			{route.icon}
			<Typography
				class='cursor-pointer'
				color={
					isActive
						? 'text-black-100'
						: 'text-black-200 group-hover:text-black-100'
				}
				text={route.title}
				variant='label1'
				weight='font-normal'
			/>
		</Link>
	</li>
)

const SettingsLeftSidebar = () => {
	const [location] = useLocation()

	return (
		<div class='flex flex-1 flex-col overflow-hidden'>
			<div class='m-5'>
				<Typography text='Account Settings' variant='h5' weight='font-bold' />
			</div>

			<div class='latest-work-list flex-1 overflow-auto'>
				<ul class='flex flex-col space-y-2'>
					{settingsRoutes.map(item => (
						<SidebarItem
							isActive={
								item.url === '/' ? false : location.startsWith(item.url)
							}
							key={item.key}
							route={item}
						/>
					))}
				</ul>
			</div>
		</div>
	)
}

export { SettingsLeftSidebar }
